import React from 'react';
import { useTranslation } from 'react-i18next';

interface SubFooterProps {
    className: string
}

const SubFooter: React.FC<SubFooterProps> = (props) => {
    const { t } = useTranslation(['common']);

    return (
        <div className={props.className + " subfooter"}>
            <p>{t('footer.productBy', { ns: 'common' })}</p>
            <a href="https://www.eventful.se/" target="_blank" rel="noopener noreferrer"><img src="https://eventfulcdn.blob.core.windows.net/flowsync/eventful_logo_light.svg" alt="Eventful" />
            </a>
        </div>
    )
}

export default SubFooter;